import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as swReg from './serviceWorkerRegistration';  // ← ADD THIS
import './index.css';
import { PermissionProvider } from './context/PermissionContext';
/* import './responsive.css';   */ // ← add this line
// -- Global error boundary � stops "Uncaught runtime errors" overlay --
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(err) { return { error: err }; }
  componentDidCatch(err, info) { console.error('[iAssets ErrorBoundary]', err, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        display:'flex', flexDirection:'column', alignItems:'center',
        justifyContent:'center', height:'100vh', gap:16, fontFamily:'DM Sans, sans-serif',
        background:'#f5f6fa',
      }}>
        <div style={{width:48,height:48,background:'#1a56db',borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:800,fontSize:18}}>iA</div>
        <div style={{fontSize:18,fontWeight:700,color:'#1e2a3b'}}>Something went wrong</div>
        <div style={{fontSize:13,color:'#94a3b8',maxWidth:360,textAlign:'center'}}>
          {this.state.error?.message || 'An unexpected error occurred.'}
        </div>
        <div style={{display:'flex',gap:10}}>
          <button
            onClick={() => this.setState({ error: null })}
            style={{padding:'9px 20px',background:'#1a56db',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer'}}
          >Try Again</button>
          <button
            onClick={() => window.location.href = '/dashboard'}
            style={{padding:'9px 20px',background:'#fff',color:'#1e2a3b',border:'1px solid #e2e8f0',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer'}}
          >Go to Dashboard</button>
        </div>
      </div>
    );
  }
}
// ── Add this function anywhere in index.js ────────────────────
/* function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then(reg => {
          console.log('[iAssets] SW registered:', reg.scope);

          // Check for updates every 30 min
          setInterval(() => reg.update(), 30 * 60 * 1000);

          // Notify user when new version is available
          reg.addEventListener('updatefound', () => {
            const newSW = reg.installing;
            newSW?.addEventListener('statechange', () => {
              if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available — you can show a toast here
                console.log('[iAssets] New version available — refresh to update');
                window.dispatchEvent(new CustomEvent('sw-update-available'));
              }
            });
          });
        })
        .catch(err => console.warn('[iAssets] SW registration failed:', err));
    });
  }
} */

// ── Call it at the bottom of index.js ────────────────────────
//registerSW();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
    <PermissionProvider>
    <App />
  </PermissionProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
swReg.register();  // ← ADD THIS AT THE VERY BOTTOM